var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.restrictMultipleCitySelection)?_c('b-form-row',[_c('b-col',[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(_vm._s(_vm.DISPLAY_MESSAGES.MULTIPLE_CITIES_ADDRESS_SETUP_ERROR))])],1)],1):_c('AddressSetup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }